export const PAYFORT_TRANSACTION_STATUS = {
  PROCESSING: 'PROCESSING',
  URL_3D: 'URL_3D',
  DONE: 'DONE',
  ERROR: 'ERROR'
};

export const TRANSACTION_STATUS = {
  PROCESSING: 'IN_PROGRESS',
  CONFIRMED: 'CONFIRMED',
  ERROR: 'FAILED'
};

export const PAYMENT_METHOD = {
  PAYFORT: 'PAYFORT',
  STRIPE: 'STRIPE',
  PAYPAL: 'PAYPAL',
  // for zero total price orders
  FAKE: 'FAKE'
};
